import React from 'react';
import { Grid } from '@mui/material';
import useLightVsDarkStyles from '../../styles/kozelBattle/lightVsDark';
import tipa from '../../assets/images/kozel_battle/tipa.png';
import tip from '../../assets/images/kozel_battle/tip.png';
import separator from '../../assets/images/kozel_battle/separator.png';
import logoBattle from '../../assets/images/kozel_battle/logo_battle.png';
import tap from '../../assets/images/kozel_battle/tap.png';

const LightVsDark: React.FC = () => {
    const classes = useLightVsDarkStyles();

    return (
        <Grid container className={classes.wrapper}>

            {/* Left side: latte_cream — tipa + logo_battle (mobile only) */}
            <Grid item xs={12} md={6} className={classes.leftSide}>
                <img src={tipa} alt="Light" className={classes.characterLeft} />
                <img src={logoBattle} alt="Light vs Dark Battle" className={classes.logoBattleMobile} />
            </Grid>

            {/* Right side: espresso_brown — tap (mobile only, on top) + tip */}
            <Grid item xs={12} md={6} className={classes.rightSide}>
                <img src={tap} alt="Tzap" className={classes.tapMobile} />
                <img src={tip} alt="Dark" className={classes.characterRight} />
            </Grid>

            {/* Desktop only: absolutely positioned elements */}
            <img src={separator} alt="" aria-hidden="true" className={classes.separatorImg} />
            <img src={separator} alt="" aria-hidden="true" className={classes.separatorImgMobile} />
            <img src={logoBattle} alt="Light vs Dark Battle" className={classes.logoBattleDesktop} />
            <img src={tap} alt="Tzap" className={classes.tapDesktop} />

        </Grid>
    );
};

export default LightVsDark;